<template>
    <section class="content">
        <app-menu v-if="isLoggedIn"></app-menu>
        <div class="container-fluid">
            <div class="block-header">
                <h2>Case</h2>
            </div>

            <div class="row clearfix">
                <form class="form-inline" id="caseform" enctype="multipart/form-data">
                    <input id="id" name="id" type="hidden">
                    <div id="custom-tab">
                        <div class="tab-content clearfix">
                            <div class="tab-pane active" id="general">

                                <div >
                                    Contact
                                    <select name="contact_id" id="contact_id">
                                        <option v-for="contact in contacts " v-bind:value="contact.id">{{ contact.first_name }} {{ contact.middle_name }} {{ contact.last_name }}</option>
                                    </select>
                                </div>

                                <div >
                                    Customer
                                    <select name="customer_id" id="customer_id">
                                        <option v-for="customer in customers " v-bind:value="customer.id">{{ customer.first_name }} {{ customer.middle_name }} {{ customer.last_name }}</option>
                                    </select>
                                </div>
                                <div >
                                    Source
                                    <select name="source" id="source_id">
                                        <option value="email">Email</option>
                                        <option value="phone">Phone</option>
                                        <option value="web">Web</option>
                                        <option value="other">Other</option>
                                    </select>
                                </div>
                                <div >
                                    Status
                                    <select name="status" id="status_id">
                                        <option value="open">Open</option>
                                        <option value="in_progress">In Progress</option>
                                        <option value="resolved">Resolved</option>
                                        <option value="closed">Closed</option>
                                    </select>
                                </div>
                                <div >
                                    Priority
                                    <select name="priority" id="priority_id">
                                        <option value="low">Low</option>
                                        <option value="normal">Normal</option>
                                        <option value="high">High</option>
                                    </select>
                                </div>

                                <div >
                                    Assigned To
                                    <select name="assigned_to" id="assigned_to_id">
                                        <option value="none" selected>None</option>
                                    </select>
                                </div>

                                <div id="subject_id">
                                    <label>Subject:</label>
                                    <input type="text" id="subject" name="subject">
                                </div>
                                <div id="description_id">
                                    <label>Description:</label>
                                    <textarea id="description_id" name="description" />
                                </div>
                                <div id="resolution_id">
                                    <label>Resolution:</label>
                                    <textarea id="resolution_id" name="resolution" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <section class="submit-section">
                        <button id="add-case" type="button" v-on:click="addCase()" class="btn general-button btn-default">Save</button>
                        <button id="cancel-case" type="button" class="btn general-button btn-default">Done</button>
                    </section>
                </form>
            </div>

            <div class="row clearfix">

            </div>
        </div>
    </section>
</template>
<script>
    import Vue from 'vue';
    import FrontMenu from '@/components/partials/FrontMenu';
    import SessioMixin from '../../mixins/sessionmixin';
    Vue.component('app-menu', FrontMenu);
    import EventBus from '../event-bus';
    //import "vue-good-table/dist/vue-good-table.css";
    export default {
        name: "listBooking",
        mixins: [SessioMixin],
        // add to component
        data() {
            return {
                isLoggedIn: false,
                contacts: [{
                        id: 0,
                        first_name: '',
                        middle_name: '',
                        last_name: '',
                    }],
                customers: [{
                        id: 0,
                        first_name: '',
                        middle_name: '',
                        last_name: '',
                    }]
            };
        }, beforeMount: function () {
            $(".removeActive").removeClass('active');
            $("#menucases").addClass('active');
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (!check) {
                app.$router.push({path: '/login'});
            }
            if (check != null) {
                this.isLoggedIn = true;
            }
        },
        mounted: function () {
            if (localStorage.getItem("menu_small") == '1') {
                this.menuSmall();
            } else {
                this.menuBig();
            }
            this.populateData();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        methods: {
            populateData: function () {
                this.getContacts();
                this.getCustomers();
            },
            getContacts: function () {
                var self = this;
                HTTP.get(`getcontacts`)
                        .then(response => {
                            // JSON responses are automatically parsed.
                            self.contacts = response.data;
                            //self.selectedBranch = self.branchList[0].ItmId;
                        })
                        .catch(e => {
                            //console.log(e);
                            //this.errors.push(e);
                        });
            },
            getCustomers: function () {
                var self = this;
                HTTP.get(`getcustomers`)
                        .then(response => {
                            // JSON responses are automatically parsed.
                            //this.posts = response.data;
                            self.customers = response.data;
                            //self.selectedBranch = self.branchList[0].ItmId;
                        })
                        .catch(e => {
                            //console.log(e);
                            //this.errors.push(e);
                        });
            },
            createCase: function () {
                var self = this;
                HTTP.get(`createcase`)
                        .then(response => {
                            // JSON responses are automatically parsed.
                            //this.posts = response.data;
                            self.customers = response.data;
                            //self.selectedBranch = self.branchList[0].ItmId;
                        })
                        .catch(e => {
                            //console.log(e);
                            //this.errors.push(e);
                        });
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/cases/CaseComponent.vue